<template>
  <Button @click="handleClick" :class="'c-button c-button-' + type" :loading="loading" :disabled="disabled">{{ text }}</Button>
</template>

<script>
export default {
  name: 'c-button',
  props: {
    onClick: Function,
    text: String,
    type: {
      default: 'primary',
      type: String
    },
    loading: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    handleClick() {
      this.onClick && this.onClick()
      this.$emit('click');
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
